export default __webpack_public_path__ + "static/media/feature3-3.721e3c77.png";